"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enable = void 0;
exports.deleteCookies = deleteCookies;
exports.getCookies = getCookies;
exports.getResponseBody = getResponseBody;
var trim_1 = __importDefault(require("licia/trim"));
var each_1 = __importDefault(require("licia/each"));
var decodeUriComponent_1 = __importDefault(require("licia/decodeUriComponent"));
var rmCookie_1 = __importDefault(require("licia/rmCookie"));
var isNative_1 = __importDefault(require("licia/isNative"));
var contain_1 = __importDefault(require("licia/contain"));
var now_1 = __importDefault(require("licia/now"));
var isStr_1 = __importDefault(require("licia/isStr"));
var isBlob_1 = __importDefault(require("licia/isBlob"));
var isUndef_1 = __importDefault(require("licia/isUndef"));
var convertBin_1 = __importDefault(require("licia/convertBin"));
var request_1 = require("../lib/request");
var connector_1 = __importDefault(require("../lib/connector"));
var util_1 = require("../lib/util");
function deleteCookies(params) {
    (0, rmCookie_1.default)(params.name);
}
function getCookies() {
    var cookies = [];
    var cookie = document.cookie;
    if ((0, trim_1.default)(cookie) !== '') {
        (0, each_1.default)(cookie.split(';'), function (value) {
            value = value.split('=');
            var name = (0, trim_1.default)(value.shift());
            value = (0, decodeUriComponent_1.default)(value.join('='));
            cookies.push({
                name: name,
                value: value,
            });
        });
    }
    return { cookies: cookies };
}
var resTxtMap = new Map();
var isEnable = false;
var enable = function () {
    isEnable = true;
    (0, each_1.default)(triggers, function (trigger) { return trigger(); });
    triggers = [];
};
exports.enable = enable;
function getResponseBody(params) {
    return {
        base64Encoded: false,
        body: resTxtMap.get(params.requestId),
    };
}
function enableXhr() {
    var winXhrProto = window.XMLHttpRequest.prototype;
    var origSend = winXhrProto.send;
    var origOpen = winXhrProto.open;
    var origSetRequestHeader = winXhrProto.setRequestHeader;
    winXhrProto.open = function (method, url) {
        if (!isValidUrl(url)) {
            return origOpen.apply(this, arguments);
        }
        var xhr = this;
        var req = (xhr.chobitsuRequest = new request_1.XhrRequest(xhr, method, url));
        bindRequestEvent(req, 'XHR');
        origOpen.apply(this, arguments);
    };
    winXhrProto.send = function (data) {
        var req = this.chobitsuRequest;
        if (req)
            req.handleSend(data);
        origSend.apply(this, arguments);
    };
    winXhrProto.setRequestHeader = function (key, val) {
        var req = this.chobitsuRequest;
        if (req) {
            req.handleReqHeadersSet(key, val);
        }
        origSetRequestHeader.apply(this, arguments);
    };
}
function enableFetch() {
    var isFetchSupported = false;
    if (window.fetch) {
        isFetchSupported = (0, isNative_1.default)(window.fetch);
        if (!isFetchSupported) {
            if (navigator.serviceWorker) {
                isFetchSupported = true;
            }
            if (window.Request && (0, isNative_1.default)(window.Request)) {
                isFetchSupported = true;
            }
        }
    }
    if (!isFetchSupported)
        return;
    var origFetch = window.fetch;
    window.fetch = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var req = new (request_1.FetchRequest.bind.apply(request_1.FetchRequest, __spreadArray([void 0], args, false)))();
        bindRequestEvent(req, 'Fetch');
        var fetchResult = origFetch.apply(void 0, args);
        req.send(fetchResult);
        return fetchResult;
    };
}
function bindRequestEvent(req, type) {
    req.on('send', function (id, data) {
        var request = {
            method: data.method,
            url: data.url,
            headers: data.reqHeaders,
        };
        if (data.data) {
            request.postData = data.data;
        }
        trigger('Network.requestWillBeSent', {
            requestId: id,
            type: type,
            request: request,
            timestamp: data.time / 1000,
        });
    });
    req.on('headersReceived', function (id, data) {
        trigger('Network.responseReceivedExtraInfo', {
            requestId: id,
            blockedCookies: [],
            headers: data.resHeaders,
        });
    });
    req.on('done', function (id, data) {
        var response = {
            status: data.status,
        };
        if (data.resHeaders) {
            response.headers = data.resHeaders;
        }
        trigger('Network.responseReceived', {
            requestId: id,
            type: type,
            response: response,
            timestamp: data.time / 1000,
        });
        resTxtMap.set(id, data.resTxt);
        trigger('Network.loadingFinished', {
            requestId: id,
            encodedDataLength: data.size,
            timestamp: data.time / 1000,
        });
    });
    req.on('error', function (id, data) {
        trigger('Network.loadingFailed', {
            requestId: id,
            errorText: data.errorText,
            timestamp: data.time / 1000,
            type: type,
        });
    });
}
function enableWebSocket() {
    var origWebSocket = window.WebSocket;
    function WebSocket(url, protocols) {
        var ws = new origWebSocket(url, protocols);
        if (!isValidUrl(url)) {
            return ws;
        }
        var requestId = (0, util_1.createId)();
        trigger('Network.webSocketCreated', {
            requestId: requestId,
            url: url,
        });
        ws.addEventListener('open', function () {
            trigger('Network.webSocketWillSendHandshakeRequest', {
                requestId: requestId,
                timestamp: (0, now_1.default)() / 1000,
                request: {
                    headers: {},
                },
            });
            trigger('Network.webSocketHandshakeResponseReceived', {
                requestId: requestId,
                timeStamp: (0, now_1.default)() / 1000,
                response: {
                    status: 101,
                    statusText: 'Switching Protocols',
                },
            });
        });
        ws.addEventListener('message', function (e) {
            return __awaiter(this, void 0, void 0, function () {
                var payloadData, opcode;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            payloadData = e.data;
                            if ((0, isUndef_1.default)(payloadData)) {
                                return [2];
                            }
                            opcode = 1;
                            if (!!(0, isStr_1.default)(payloadData)) return [3, 3];
                            opcode = 2;
                            if (!(0, isBlob_1.default)(payloadData)) return [3, 2];
                            return [4, convertBin_1.default.blobToArrBuffer(payloadData)];
                        case 1:
                            payloadData = _a.sent();
                            _a.label = 2;
                        case 2:
                            payloadData = (0, convertBin_1.default)(payloadData, 'base64');
                            _a.label = 3;
                        case 3:
                            trigger('Network.webSocketFrameReceived', {
                                requestId: requestId,
                                timestamp: (0, now_1.default)() / 1000,
                                response: {
                                    opcode: opcode,
                                    payloadData: payloadData,
                                },
                            });
                            return [2];
                    }
                });
            });
        });
        var origSend = ws.send;
        ws.send = function (data) {
            if (!(0, isUndef_1.default)(data)) {
                frameSent(data);
            }
            return origSend.call(this, data);
        };
        function frameSent(data) {
            return __awaiter(this, void 0, void 0, function () {
                var opcode, payloadData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            opcode = 1;
                            payloadData = data;
                            if (!!(0, isStr_1.default)(data)) return [3, 3];
                            opcode = 2;
                            if (!(0, isBlob_1.default)(payloadData)) return [3, 2];
                            return [4, convertBin_1.default.blobToArrBuffer(payloadData)];
                        case 1:
                            payloadData = _a.sent();
                            _a.label = 2;
                        case 2:
                            payloadData = (0, convertBin_1.default)(data, 'base64');
                            _a.label = 3;
                        case 3:
                            trigger('Network.webSocketFrameSent', {
                                requestId: requestId,
                                timestamp: (0, now_1.default)() / 1000,
                                response: {
                                    opcode: opcode,
                                    payloadData: payloadData,
                                },
                            });
                            return [2];
                    }
                });
            });
        }
        ws.addEventListener('close', function () {
            trigger('Network.webSocketClosed', {
                requestId: requestId,
                timestamp: (0, now_1.default)() / 1000,
            });
        });
        ws.addEventListener('error', function () {
            trigger('Network.webSocketFrameError', {
                requestId: requestId,
                timestamp: (0, now_1.default)() / 1000,
                errorMessage: 'WebSocket error',
            });
        });
        return ws;
    }
    WebSocket.prototype = origWebSocket.prototype;
    WebSocket.CLOSED = origWebSocket.CLOSED;
    WebSocket.CLOSING = origWebSocket.CLOSING;
    WebSocket.CONNECTING = origWebSocket.CONNECTING;
    WebSocket.OPEN = origWebSocket.OPEN;
    window.WebSocket = WebSocket;
}
function isValidUrl(url) {
    return !(0, contain_1.default)(url, '__chobitsu-hide__=true');
}
var triggers = [];
function trigger(method, params) {
    if (isEnable) {
        connector_1.default.trigger(method, params);
    }
    else {
        triggers.push(function () { return connector_1.default.trigger(method, params); });
    }
}
enableXhr();
enableFetch();
enableWebSocket();
